import { render, staticRenderFns } from "./Bestfuturehomes.vue?vue&type=template&id=7e882d18"
import script from "./Bestfuturehomes.vue?vue&type=script&lang=js"
export * from "./Bestfuturehomes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports